export default __webpack_public_path__ + "static/media/live-streaming-cover.70da91f4.webp";